module.exports = __webpack_public_path__ + "img/sub-frame.1e2ac0a0.webp";